import React from "react";
import PurchaseGroupPieChart from "./PurchseGroupPieChart";
import { FiArrowUpRight } from "react-icons/fi";

const InventoryPurchaseTables = ({
    purchaseRequisitions = [],
    purchaseItems = [],
    handleChange,
    formatSalesValue,
    searchType,
    searchValue,
    searchLoading,
    searchError,
    searchPurchases
}) => {
    const isSearching = !!searchType && !!searchValue;

    return (
        <div className="px-8 relative">

            <div className="grid grid-cols-5 gap-4 mb-9">
                <div className="col-span-2">
                    <PurchaseGroupPieChart purchaseItems={purchaseItems} />
                </div>

                {/* ================= PURCHASE REQUISITION TABLE ================= */}
                <div className="col-span-3 w-full">
                    <div className="w-full border border-gray-300 rounded-lg shadow-md max-h-[500px] overflow-x-auto overflow-y-auto relative tiny-scrollbar">
                        <table className="w-full border-collapse text-center text-sm">

                            <thead className="bg-gray-100 sticky top-0 z-10">
                                <tr>
                                    {[
                                        "S.N", "Vendor", "Ordered", "Received",
                                        "Tax", "Total", "GRN", "Bill No.", "View"
                                    ].map((header, index) => (
                                        <th key={index} className="p-2.5 text-xs uppercase tracking-wider whitespace-nowrap bg-gray-100 font-medium text-gray-700">
                                            {header}
                                        </th>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {/* ================= SEARCH MODE ================= */}
                                {isSearching ? (
                                    searchLoading ? (
                                        <tr>
                                            <td colSpan="9" className="py-4 text-gray-500">
                                                Searching...
                                            </td>
                                        </tr>
                                    ) : searchError ? (
                                        <tr>
                                            <td colSpan="9" className="py-4 text-red-500">
                                                {searchError}
                                            </td>
                                        </tr>
                                    ) : searchPurchases.length === 0 ? (
                                        <tr>
                                            <td colSpan="9" className="py-3 text-gray-500">
                                                No search results found!
                                            </td>
                                        </tr>
                                    ) : (
                                        searchPurchases.map((item, index) => (
                                            <tr
                                                key={item.IDIntbl_PurchaseRequisition}
                                                className="border-b border-gray-300"
                                            >
                                                <td className="p-2 whitespace-nowrap">{index + 1}</td>
                                                <td className="p-2 whitespace-nowrap">{item.Company_Name || 'N/A'}</td>
                                                <td className="p-2 whitespace-nowrap">
                                                    {new Date(item.Date).toLocaleDateString('en-GB')}
                                                </td>
                                                <td className="p-2 whitespace-nowrap">
                                                    {new Date(item.ReceivedDate).toLocaleDateString('en-GB')}
                                                </td>
                                                <td className="p-2 whitespace-nowrap">{item.TaxAmount || '0.00'}</td>
                                                <td className="p-2 whitespace-nowrap">
                                                    {formatSalesValue(item.TotalAmount) || '0.00'}
                                                </td>
                                                <td className="p-2 whitespace-nowrap">{item.GRN || 'N/A'}</td>
                                                <td className="p-2 whitespace-nowrap">{item.purchaseBillNumber}</td>

                                                <td className="p-2 whitespace-nowrap">
                                                    <button
                                                        onClick={() => handleChange(item)}
                                                        className="p-1.5 flex items-center justify-center border-2 border-green-600 text-green-600 rounded-md hover:bg-green-600 hover:text-white transition-colors"
                                                        title="Open"
                                                    >
                                                        <FiArrowUpRight size={16} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )
                                ) : (
                                    /* ================= DEFAULT MODE ================= */
                                    purchaseRequisitions.length === 0 ? (
                                        <tr>
                                            <td colSpan="9" className="py-3">No data available!</td>
                                        </tr>
                                    ) : (
                                        purchaseRequisitions.map((item, index) => (
                                            <tr key={item.IDIntbl_PurchaseRequisition} className="border-b border-gray-300">
                                                <td className="p-2 whitespace-nowrap">{index + 1}</td>
                                                <td className="p-2 whitespace-nowrap">{item.Company_Name || 'N/A'}</td>
                                                <td className="p-2 whitespace-nowrap">
                                                    {new Date(item.Date).toLocaleDateString('en-GB')}
                                                </td>
                                                <td className="p-2 whitespace-nowrap">
                                                    {new Date(item.ReceivedDate).toLocaleDateString('en-GB')}
                                                </td>
                                                <td className="p-2 whitespace-nowrap">{item.TaxAmount || '0.00'}</td>
                                                <td className="p-2 whitespace-nowrap">
                                                    {formatSalesValue(item.TotalAmount) || '0.00'}
                                                </td>
                                                <td className="p-2 whitespace-nowrap">{item.GRN || 'N/A'}</td>
                                                <td className="p-2 whitespace-nowrap">{item.purchaseBillNumber}</td>

                                                <td className="p-2 whitespace-nowrap flex justify-center">
                                                    <button
                                                        onClick={() => handleChange(item)}
                                                        className="p-1 border-2 border-green-600 text-green-600 rounded-md hover:bg-green-600 hover:text-white transition-colors"
                                                        title="Open"
                                                    >
                                                        <FiArrowUpRight size={16} />
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    )
                                )}
                            </tbody>

                            {!isSearching &&
                                <tfoot className="sticky bottom-0 bg-gray-100 font-semibold z-10">
                                    <tr>
                                        <td colSpan="4" className="px-2.5 py-2 text-left">
                                            Count: {purchaseRequisitions.length}
                                        </td>

                                        <td className="px-2.5 py-2 whitespace-nowrap">
                                            {formatSalesValue(
                                                purchaseRequisitions.reduce(
                                                    (acc, item) => acc + parseFloat(item.TaxAmount || 0),
                                                    0
                                                )
                                            )}
                                        </td>

                                        <td className="px-2.5 py-2 whitespace-nowrap">
                                            {formatSalesValue(
                                                purchaseRequisitions.reduce(
                                                    (acc, item) => acc + parseFloat(item.TotalAmount || 0),
                                                    0
                                                )
                                            )}
                                        </td>

                                        <td colSpan="3"></td>
                                    </tr>
                                </tfoot>
                            }
                        </table>
                    </div>
                </div>
            </div>

            {/* ================= PURCHASE ITEMS TABLE ================= */}
            <div className="w-full border border-gray-300 rounded-lg shadow-md max-h-[450px] overflow-x-auto overflow-y-auto tiny-scrollbar">
                <table className="w-full border-collapse text-center text-sm">

                    <thead className="bg-gray-100 sticky top-0 z-10">
                        <tr>
                            {[
                                "S.N", "Name", "Group Name", "Vendor Name",
                                "Unit", "UOM", "Rate", "Total", "Tax"
                            ].map((header, index) => (
                                <th key={index} className="px-3 py-2.5 text-xs uppercase tracking-wider whitespace-nowrap bg-gray-100 font-medium text-gray-700">
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>

                    <tbody>
                        {purchaseItems.length === 0 ? (
                            <tr>
                                <td colSpan="9" className="py-3">No data available!</td>
                            </tr>
                        ) : (
                            purchaseItems.map((item, index) => (
                                <tr key={index} className="border-b border-gray-300 hover:bg-gray-50">
                                    <td className="px-3 py-2 whitespace-nowrap">{index + 1}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{item.Name || 'N/A'}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{item.GroupName || 'N/A'}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{item.Company_Name || 'N/A'}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{item.Count || 'N/A'}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">{item.UOM || 'N/A'}</td>
                                    <td className="px-3 py-2 whitespace-nowrap">
                                        {formatSalesValue(item.Rate) || '0.00'}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap">
                                        {formatSalesValue(item.Total) || '0.00'}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap">
                                        {item.Taxable || '0.00'}
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default InventoryPurchaseTables;